export default class UnlinkCardResponse {
    constructor (json) {
        this.json = json
    }

    getProperty (name) {
        return this.json[name]
    }

    toObj () {
        return this.json
    }
}

// {
//     "responseCode": "SUCCESS",
//     "linkResult": "UNLINKED"
// }



// WEBPACK FOOTER //
// ./src/models/responses/UnlinkCardResponse.js